var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "活动" + (_vm.eventsType === "add" ? "添加" : "编辑"),
        visible: _vm.dialogVisible,
        width: "1000px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.handleClose,
      },
    },
    [
      _vm.dialogVisible
        ? _c("div", { staticClass: "fc" }, [
            _c("div", { staticStyle: { width: "800px" } }, [
              _c(
                "div",
                [
                  _c(
                    "el-form",
                    {
                      ref: "ruleForm",
                      staticClass: "demo-ruleForm",
                      attrs: {
                        model: _vm.ruleForm,
                        rules: _vm.rules,
                        "label-width": "130px",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "活动上下线状态:",
                            prop: "rankSwitch",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.ruleForm.rankSwitch,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "rankSwitch", $$v)
                                },
                                expression: "ruleForm.rankSwitch",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("上线"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("下线"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "活动渠道", prop: "unionCode" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                disabled: _vm.unionCodeBoole,
                                placeholder: "选择活动渠道",
                                clearable: "",
                              },
                              model: {
                                value: _vm.ruleForm.unionCode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "unionCode", $$v)
                                },
                                expression: "ruleForm.unionCode",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { value: "TB", label: "淘宝" },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { value: "JD", label: "京东" },
                              }),
                              _vm._v(" "),
                              _vm.actionType === "income"
                                ? _c("el-option", {
                                    attrs: { value: "PDD", label: "拼多多" },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.actionType === "income"
                                ? _c("el-option", {
                                    attrs: { value: "WPH", label: "唯品会" },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.actionType === "income"
                                ? _c("el-option", {
                                    attrs: { value: "DY", label: "抖音" },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "Explanation_text" }, [
                            _vm._v("相同渠道下，活动时间不能重叠"),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "活动名称", prop: "title" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入" },
                            model: {
                              value: _vm.ruleForm.title,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "title", $$v)
                              },
                              expression: "ruleForm.title",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "头图", prop: "mainPic" } },
                        [
                          _c(
                            "div",
                            [
                              _c("upload", {
                                attrs: {
                                  name: "mainPic",
                                  "img-url": _vm.ruleForm.mainPic,
                                },
                                on: {
                                  pictureAddress: function ($event) {
                                    return _vm.onPictureAddress($event)
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "Explanation_text" }, [
                                _vm._v(
                                  "\n                建议尺寸750*450 PNG图片(商品信息加载前展示)\n              "
                                ),
                              ]),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "活动背景色值", prop: "color" } },
                        [
                          _c(
                            "div",
                            { staticClass: "flex" },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入色号，例：“#FFFFFF”",
                                },
                                model: {
                                  value: _vm.ruleForm.color,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm, "color", $$v)
                                  },
                                  expression: "ruleForm.color",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "fc" },
                                [
                                  _c("el-color-picker", {
                                    model: {
                                      value: _vm.ruleForm.color,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.ruleForm, "color", $$v)
                                      },
                                      expression: "ruleForm.color",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "Explanation_text" }, [
                            _vm._v(
                              "\n              选取或填写色号(#******形式填写)设置页面背景色，默认白色#FFFFFF\n            "
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.actionType === "income"
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "统计类型", prop: "indexType" } },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  attrs: { disabled: _vm.indexTypeBoole },
                                  model: {
                                    value: _vm.ruleForm.indexType,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ruleForm, "indexType", $$v)
                                    },
                                    expression: "ruleForm.indexType",
                                  },
                                },
                                [
                                  _c("el-radio", { attrs: { label: 1 } }, [
                                    _vm._v("GMV"),
                                  ]),
                                  _vm._v(" "),
                                  _c("el-radio", { attrs: { label: 2 } }, [
                                    _vm._v("佣金"),
                                  ]),
                                  _vm._v(" "),
                                  _c("el-radio", { attrs: { label: 3 } }, [
                                    _vm._v("订单量"),
                                  ]),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "Explanation_text" }, [
                                _vm.ruleForm.indexType === 1
                                  ? _c("div", [
                                      _vm._v(
                                        "\n                统计活动开始时间至结束时间周期内报名会员有效订单GMV（商品交易总额）\n              "
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.ruleForm.indexType === 2
                                  ? _c("div", [
                                      _vm._v(
                                        "\n                统计活动开始时间至结束时间周期内报名会员有效有效自购订单佣金\n              "
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.ruleForm.indexType === 3
                                  ? _c("div", [
                                      _vm._v(
                                        "\n                统计活动开始时间至结束时间周期内报名会员有效订单量\n              "
                                      ),
                                    ])
                                  : _vm._e(),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.actionType === "income"
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "奖励门槛", prop: "rankLimit" } },
                            [
                              _c(
                                "el-input",
                                {
                                  attrs: {
                                    type: "number",
                                    placeholder: "请输入内容",
                                  },
                                  model: {
                                    value: _vm.ruleForm.rankLimit,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ruleForm, "rankLimit", $$v)
                                    },
                                    expression: "ruleForm.rankLimit",
                                  },
                                },
                                [
                                  _c("template", { slot: "append" }, [
                                    _vm._v("元/单"),
                                  ]),
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "Explanation_text" }, [
                                _vm._v(
                                  "\n              对应统计类型的奖励门槛，GMV和佣金类型单位是“元”，订单量单位为“单”，报名会员出单数据≥该门槛时才会有奖励\n            "
                                ),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("el-form-item", { attrs: { label: "活动时间" } }, [
                        _c(
                          "div",
                          {
                            staticClass: "flex",
                            staticStyle: { "margin-bottom": "10px" },
                          },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { prop: "rankStartTime" } },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    disabled: _vm.rankStartBoole,
                                    "value-format": "yyyy-MM-dd HH:mm:ss",
                                    type: "datetime",
                                    placeholder: "选择活动开始时间",
                                  },
                                  model: {
                                    value: _vm.ruleForm.rankStartTime,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.ruleForm,
                                        "rankStartTime",
                                        $$v
                                      )
                                    },
                                    expression: "ruleForm.rankStartTime",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v("\n              --\n              "),
                            _c(
                              "el-form-item",
                              { attrs: { prop: "rankEndTime" } },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    "value-format": "yyyy-MM-dd HH:mm:ss",
                                    type: "datetime",
                                    placeholder: "选择活动结束时间",
                                  },
                                  model: {
                                    value: _vm.ruleForm.rankEndTime,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ruleForm, "rankEndTime", $$v)
                                    },
                                    expression: "ruleForm.rankEndTime",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "Explanation_text" }, [
                          _vm._v(
                            "\n              注意！活动设置后切勿随意更改时间，避免统计时间段的更改对用户数据造成不必要的干扰!\n            "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("el-form-item", { attrs: { label: "报名时间" } }, [
                        _c(
                          "div",
                          {
                            staticClass: "flex",
                            staticStyle: { "margin-bottom": "10px" },
                          },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { prop: "signStartTime" } },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    disabled: _vm.signStartBoole,
                                    "value-format": "yyyy-MM-dd HH:mm:ss",
                                    type: "datetime",
                                    placeholder: "选择报名开始时间",
                                  },
                                  model: {
                                    value: _vm.ruleForm.signStartTime,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.ruleForm,
                                        "signStartTime",
                                        $$v
                                      )
                                    },
                                    expression: "ruleForm.signStartTime",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v("\n              --\n              "),
                            _c(
                              "el-form-item",
                              { attrs: { prop: "signEndTime" } },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    "value-format": "yyyy-MM-dd HH:mm:ss",
                                    type: "datetime",
                                    placeholder: "选择报名结束时间",
                                  },
                                  model: {
                                    value: _vm.ruleForm.signEndTime,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ruleForm, "signEndTime", $$v)
                                    },
                                    expression: "ruleForm.signEndTime",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "Explanation_text" }, [
                          _vm._v(
                            "\n              注意！活动设置后切勿随意更改时间，避免统计时间段的更改对用户数据造成不必要的干扰!\n            "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "数据统计截止时间" } },
                        [
                          _c(
                            "div",
                            { staticStyle: { "margin-bottom": "10px" } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { prop: "deadlineTime" } },
                                [
                                  _c("el-date-picker", {
                                    attrs: {
                                      "value-format": "yyyy-MM-dd HH:mm:ss",
                                      type: "datetime",
                                      placeholder: "数据统计截止时间",
                                    },
                                    model: {
                                      value: _vm.ruleForm.deadlineTime,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.ruleForm,
                                          "deadlineTime",
                                          $$v
                                        )
                                      },
                                      expression: "ruleForm.deadlineTime",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "Explanation_text" }, [
                            _vm._v(
                              "\n              数据统计截止时间需于活动结束后至少7天开始，待数据统计完成后方可结算奖励（以避免退换货影响数据准确性）。\n            "
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "报名弹窗文案", prop: "signTips" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入",
                              autosize: "",
                              type: "textarea",
                            },
                            model: {
                              value: _vm.ruleForm.signTips,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "signTips", $$v)
                              },
                              expression: "ruleForm.signTips",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "Explanation_text" },
                            [
                              _vm._v(
                                "\n              报名提示弹窗所需的介绍文案，可以简略提示活动时间、奖励规则等\n              "
                              ),
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    placement: "right",
                                    width: "820",
                                    trigger: "hover",
                                  },
                                },
                                [
                                  _c("div", [
                                    _c("img", {
                                      staticStyle: {
                                        width: "800px",
                                        height: "630px",
                                      },
                                      attrs: {
                                        src: require("@/assets/marketingCampaign/HorseRacing.png"),
                                        alt: "",
                                      },
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        color: "#389bff",
                                        cursor: "pointer",
                                      },
                                      attrs: { slot: "reference" },
                                      slot: "reference",
                                    },
                                    [_vm._v("查看示例>>")]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "活动跳转入口",
                            prop: "activityPage",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "flex" },
                            [
                              _c("el-input", {
                                staticStyle: { width: "600px" },
                                attrs: {
                                  placeholder: "请选择活动 or 粘贴链接到此处",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.ruleForm.activityPage,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm, "activityPage", $$v)
                                  },
                                  expression: "ruleForm.activityPage",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticStyle: { "margin-left": "10px" } },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "pointer",
                                      staticStyle: { color: "#389bff" },
                                      on: { click: _vm.onOfficialEvent },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  去选择\n                "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm.ruleForm.ActivityName
                                ? _c("div", {
                                    staticStyle: {
                                      "margin-top": "6px",
                                      background: "#eee",
                                      width: "fit-content",
                                      padding: "0 20px",
                                      "border-radius": "6px",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "Explanation_text" }, [
                            _vm._v(
                              "\n              配置后，用户点击 “去活动会场分享红包冲榜”\n              按钮将跳转至对应超红活动页面\n            "
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "奖励设置",
                            rules: _vm.rules.rewardList,
                          },
                        },
                        _vm._l(_vm.ruleForm.rewardList, function (item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "flex mb10" },
                            [
                              _c(
                                "div",
                                { staticClass: "scalation_Condition flex fc" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "fc checkbox",
                                      staticStyle: { width: "80px" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  区间" +
                                          _vm._s(index + 1) +
                                          "\n                "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-form-item",
                                    {
                                      staticStyle: {
                                        "margin-bottom": "0",
                                        "border-right": "1px solid #ccc",
                                      },
                                      attrs: {
                                        prop: "rewardList[" + index + "].start",
                                        rules: _vm.rules.rewardStart,
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticStyle: {
                                          height: "38px",
                                          width: "100px",
                                        },
                                        attrs: {
                                          placeholder: "请输入名次",
                                          type: "number",
                                          min: "1",
                                        },
                                        model: {
                                          value: item.start,
                                          callback: function ($$v) {
                                            _vm.$set(item, "start", _vm._n($$v))
                                          },
                                          expression: "item.start",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        "border-right": "1px solid #ccc",
                                        padding: "0 20px",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  ~\n                "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-form-item",
                                    {
                                      staticStyle: {
                                        "margin-bottom": "0",
                                        "border-right": "1px solid #ccc",
                                      },
                                      attrs: {
                                        prop: "rewardList[" + index + "].end",
                                        rules: _vm.rules.rewardEnd,
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticStyle: {
                                          height: "38px",
                                          width: "100px",
                                        },
                                        attrs: {
                                          placeholder: "请输入名次",
                                          type: "number",
                                          min: "1",
                                        },
                                        model: {
                                          value: item.end,
                                          callback: function ($$v) {
                                            _vm.$set(item, "end", _vm._n($$v))
                                          },
                                          expression: "item.end",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        "border-right": "1px solid #ccc",
                                        padding: "0 20px",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  名\n                "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-form-item",
                                    {
                                      staticStyle: {
                                        "margin-bottom": "0",
                                        "border-right": "1px solid #ccc",
                                      },
                                      attrs: {
                                        prop: "rewardList[" + index + "].value",
                                        rules: _vm.rules.rewardValue,
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticStyle: {
                                          height: "38px",
                                          width: "100px",
                                        },
                                        attrs: {
                                          placeholder: "请输入奖励金额",
                                          type: "number",
                                          min: "0",
                                        },
                                        model: {
                                          value: item.value,
                                          callback: function ($$v) {
                                            _vm.$set(item, "value", _vm._n($$v))
                                          },
                                          expression: "item.value",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticStyle: { padding: "0 20px" } },
                                    [_vm._v("元")]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              index === _vm.ruleForm.rewardList.length - 1
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "fc",
                                      staticStyle: {
                                        height: "40px",
                                        "margin-left": "10px",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            size: "mini",
                                            type: "success",
                                          },
                                          on: { click: _vm.onAddRewardRange },
                                        },
                                        [_vm._v("追加+")]
                                      ),
                                      _vm._v(" "),
                                      index !== 0
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                size: "mini",
                                                type: "danger",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onDeleteRewardRange(
                                                    index
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("删除-")]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "活动规则文案", prop: "ruleTips" } },
                        [
                          _vm.dialogVisible
                            ? [
                                _c(
                                  "div",
                                  { staticStyle: { border: "1px solid #ccc" } },
                                  [
                                    _c("Toolbar", {
                                      staticStyle: {
                                        "border-bottom": "1px solid #ccc",
                                      },
                                      attrs: {
                                        editor: _vm.editor,
                                        "default-config": _vm.toolbarConfig,
                                        mode: _vm.mode,
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("Editor", {
                                      staticStyle: {
                                        height: "250px",
                                        "overflow-y": "hidden",
                                      },
                                      attrs: {
                                        "default-config": _vm.editorConfig,
                                        mode: _vm.mode,
                                      },
                                      on: { onCreated: _vm.onCreated },
                                      model: {
                                        value: _vm.ruleForm.ruleTips,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.ruleForm,
                                            "ruleTips",
                                            $$v
                                          )
                                        },
                                        expression: "ruleForm.ruleTips",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.submitForm("ruleForm")
                                },
                              },
                            },
                            [_vm._v("确认")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.resetForm("ruleForm")
                                },
                              },
                            },
                            [_vm._v("重置")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("ActivitySelectionPopup", {
        ref: "activitySelectionPopup",
        on: { SelectEvents: _vm.onSelectEvents },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }